import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import CAStore from "../../Store/TemplateStore/template.store";

import { storeApp } from "../../Store/TemplateStore/template.action";

import Header from "../../components/Header";

import { extractPlantId } from "../../utils/Utils";

import cleaningIcon from "../../assets/cleaning_advisor_logo.svg";
import replacementIcon from "../../assets/replacement_advisor_logo.svg";

import "./index.scss";

export const store = CAStore;
//const isLocalhost = window.location.hostname === "localhost";
//const basePath = isLocalhost ? "/" : "/roadvisor/";
//const basePath = isLocalhost ? "/" : window.location.origin; 
const basePath = "/" //isLocalhost ? "/" : window.location.origin;
const Home = () => {
  const { t, i18n } = useTranslation();
  const plantId = extractPlantId();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(storeApp(null));
  }, []);

  return (
    <>
      <div className="container-main">
        <Header
        // setCleaningAdvisorHome={setCleaningAdvisorHome}
        // setReplacementAdvisorHome={setReplacementAdvisorHome}
        />
        <div className="container">
          <div className="centered-div descriptionText">
            <div className="heading-text ">
              {t("appHome.roOperationsAdvisor")}
            </div>
            <div className=" marginBtm20">
              {t("appHome.roOperationsAdvisorDescription")}
            </div>

            <div className="marginBtm20">{t("appHome.roAdvisorComponent")}</div>
            <div className="heading-text margin-left-60 ">
              {t("appHome.roAdvisor")}
            </div>

            <div className="flex-ai-center marginBtm20">
              <img className="img" src={cleaningIcon}></img>
              <div className=" margin-left-10 ">
                {t("appHome.roAdvisorDescription")}
              </div>
            </div>
            <div className="text-right pointer">
              {" "}
              <Link
                to={`${basePath}cleaningAdvisorHome?plantId=${plantId}`}
                className="descriptionText"
              >
                {t("appHome.gotoApp")}
              </Link>
            </div>
            <div className="heading-text margin-left-60">
              {t("appHome.roReplacementAdvisor")}
            </div>

            <div className="flex-ai-center">
              <img className="img" src={replacementIcon}></img>
              <div className=" margin-left-10 ">
                {t("appHome.roReplacementAdvisorDescription")}
              </div>
            </div>
            <div className="text-right pointer">
              {" "}
              <Link
                to={`${basePath}lifetimeAdvisorHome?plantId=${plantId}`}
                className="descriptionText"
              >
                {t("appHome.gotoApp")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
